// extracted by mini-css-extract-plugin
export default {"external_links":"ExternalLinks_external_links__pd-w9","icon":"ExternalLinks_icon__skGlZ"};